module.exports = __webpack_public_path__ + "static/media/genius.33749019.png";